// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountTypeAggregationDto } from './IAccountTypeAggregationDto';
import {
    IAccountTypeAggregationDtoFromJSON,
    IAccountTypeAggregationDtoFromJSONTyped,
    IAccountTypeAggregationDtoToJSON,
    IAccountTypeAggregationDtoToJSONTyped,
} from './IAccountTypeAggregationDto';

/**
 * 
 * @export
 * @interface IPlanEnrollmentMetricsResponseDto
 */
export interface IPlanEnrollmentMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanEnrollmentMetricsResponseDto
     */
    enrolled_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanEnrollmentMetricsResponseDto
     */
    unenrolled_count?: number;
    /**
     * 
     * @type {Array<IAccountTypeAggregationDto>}
     * @memberof IPlanEnrollmentMetricsResponseDto
     */
    enrolled_account_type_counts?: Array<IAccountTypeAggregationDto>;
}

/**
 * Check if a given object implements the IPlanEnrollmentMetricsResponseDto interface.
 */
export function instanceOfIPlanEnrollmentMetricsResponseDto(value: object): value is IPlanEnrollmentMetricsResponseDto {
    return true;
}

export function IPlanEnrollmentMetricsResponseDtoFromJSON(json: any): IPlanEnrollmentMetricsResponseDto {
    return IPlanEnrollmentMetricsResponseDtoFromJSONTyped(json, false);
}

export function IPlanEnrollmentMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanEnrollmentMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'enrolled_count': json['enrolled_count'] == null ? undefined : json['enrolled_count'],
        'unenrolled_count': json['unenrolled_count'] == null ? undefined : json['unenrolled_count'],
        'enrolled_account_type_counts': json['enrolled_account_type_counts'] == null ? undefined : ((json['enrolled_account_type_counts'] as Array<any>).map(IAccountTypeAggregationDtoFromJSON)),
    };
}

export function IPlanEnrollmentMetricsResponseDtoToJSON(json: any): IPlanEnrollmentMetricsResponseDto {
    return IPlanEnrollmentMetricsResponseDtoToJSONTyped(json, false);
}

export function IPlanEnrollmentMetricsResponseDtoToJSONTyped(value?: IPlanEnrollmentMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enrolled_count': value['enrolled_count'],
        'unenrolled_count': value['unenrolled_count'],
        'enrolled_account_type_counts': value['enrolled_account_type_counts'] == null ? undefined : ((value['enrolled_account_type_counts'] as Array<any>).map(IAccountTypeAggregationDtoToJSON)),
    };
}

